import React from 'react';
import './FacilityOverview.css';
import facilityImage from '../../assets/images/coatingCED.jpg';
import { FaCogs, FaBolt, FaGasPump, FaShoppingCart } from 'react-icons/fa';

const FacilityOverview = () => {
  return (
    <section className="facility-container">
      {/* Floating Triangles */}
      <div className="floating-triangles">
        {[...Array(10)].map((_, i) => (
          <div
            key={i}
            className="triangle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${i * 2}s`,
            }}
          />
        ))}
      </div>

      {/* Heading */}
      <div className="facility-heading">
        <h2>Innovativeness is Made, Not Born.</h2>
        <p>
          Sourcing materials to processing finished goods needs utmost observation. 
          But thanks to our suppliers and experienced workforce, we've become a key player in the CED Coating Industry.
        </p>
      </div>

      {/* Main Content */}
      <div className="facility-content">
        {/* Left Side */}
        <div className="facility-side left align-right">
          <div className="facility-point vertical">
            <FaCogs className="facility-icon" />
            <h4>Controlled Environment</h4>
            <p>
              Fully equipped air-conditioned lab facility including rectifier & oven.<br />
              Eliminates external dependency.
            </p>
          </div>
          <div className="facility-point vertical">
            <FaGasPump className="facility-icon" />
            <h4>Dedicated CNG Line</h4>
            <p>
              Independent natural gas supply line to ensure uninterrupted operations.
            </p>
          </div>
        </div>

        {/* Image */}
        <div className="facility-image-wrapper">
          <img src={facilityImage} alt="Facility" className="facility-image" />
        </div>

        {/* Right Side */}
        <div className="facility-side right align-left">
          <div className="facility-point vertical">
            <FaBolt className="facility-icon" />
            <h4>DG-Set Backup</h4>
            <p>
              Diesel generators ensure smooth operations even during power cuts, avoiding downtime.
            </p>
          </div>
          <div className="facility-point vertical">
            <FaShoppingCart className="facility-icon" />
            <h4>Top-notch Sourcing</h4>
            <p>
              We use top-grade materials – Henkel chemicals, Asian Paints, and more for superior quality.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FacilityOverview;
